import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './GrowthPitch.css';

function PitchCard({ icon: Icon, eyebrow, title, description, cta, link, variant, delay }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delay);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <Link
      to={link}
      ref={ref}
      className={`growthPitchCard growthPitchCard--${variant} ${visible ? 'is-visible' : ''}`}
    >
      {Icon && (
        <div className="growthPitchCard__iconWrap">
          <Icon size={28} />
        </div>
      )}
      <span className="growthPitchCard__eyebrow">{eyebrow}</span>
      <h3 className="growthPitchCard__title">{title}</h3>
      <p className="growthPitchCard__description">{description}</p>
      <span className="growthPitchCard__cta">
        {cta} <ArrowRight size={16} />
      </span>
    </Link>
  );
}

export default function GrowthPitch() {
  return (
    <section className="growthPitch">
      <div className="growthPitch__inner">
        <div className="growthPitch__grid">
          <PitchCard
            icon={null}
            eyebrow="FOR SELLERS"
            title="Get more eyes on your listing"
            description="Boost your property to the top of search results, get featured on the homepage, and significantly increase visibility to active buyers."
            cta="Learn how to boost"
            link="/boost"
            variant="seller"
            delay={0}
          />
          <PitchCard
            icon={null}
            eyebrow="FOR BUYERS"
            title="Be first to see new properties"
            description="Get instant alerts when properties match your criteria, see price drops in real-time, and unlock the tools serious buyers use."
            cta="Discover CosmoEstates Pro"
            link="/pro"
            variant="buyer"
            delay={150}
          />
        </div>
      </div>
    </section>
  );
}
